import { useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { fetchAssignedAppOwners } from '../actions/applications-owners-actions';
import AppOwnersStore from '../stores/app-owners-store';

export const useFetchAssignedAppOwners = (initialLoaded: boolean) => {
  useEffect(() => {
    initialLoaded && fetchAssignedAppOwners();
  }, [initialLoaded]);
};

export const useAppOwnersFilterOptions = () => {
  const { appOwnersFilterOptions } = useSnapshot(AppOwnersStore);
  return appOwnersFilterOptions;
};
